import { ReactNode } from 'react';
import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { FilterBody, Title, Caption } from './EnumFilter.styles';
import { RadioGroup, Option } from './RadioGroup/RadioGroup';

export interface EnumFilterProps<T> {
  readonly options: Option<T>[];
  readonly value?: T;
  readonly onChange: Setter<T>;
  readonly filterTitle: string;
  caption?: ReactNode;
  row?: boolean;
  trackingId?: LinkId;
}

export const EnumFilter = <T,>({
  options,
  value,
  onChange,
  filterTitle,
  caption,
  row,
  trackingId,
}: EnumFilterProps<T>) => (
  <FilterBody>
    <Title>{filterTitle}</Title>
    {caption && <Caption>{caption}</Caption>}
    <RadioGroup<T>
      row={row}
      radioGroupName={filterTitle}
      options={options}
      value={value}
      onChange={onChange}
      trackingId={trackingId}
    />
  </FilterBody>
);
